import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../GlobalServices/Destinations/Destinations.css";

const GovCustomerService = () => {
  return (
    <>
      <div className="Destination govcustomservice">
        <div className="container ServiceOffering">
          {/* <div className="row">
                        <div className="col-md-12 ">
                            <div className="d-flex justify-content-center align-items-center flex-column">
                                <h1 className="headings text-center">
                                    <span>Excellent </span>Customer Service
                                </h1>

                            </div>
                        </div>
                    </div> */}
          <div className="row px-lg-5 px-md-0 px-4 mlTab">
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3 d-flex justify-content-center">
              <div className="DT-box1 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter1.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-govt">
                      Passport and Visa
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      In addition to arranging packages and tickets, we will
                      help coordinate visas and passports necessary for
                      international travel.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter2.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-govt">
                      Concierge Services
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      When traveling abroad, our team can arrange restaurant
                      reservations, tour bookings and lost luggage assistance
                      services as needed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/enter4.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-govt">
                      Planning Your Itinerary
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      Our travel experts can create an itinerary tailored to
                      your interests, budget and time constraints for a truly
                      custom experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GovCustomerService;
